// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"315":"7ddf3150","468":"74acbaaf"}[chunkId] + ".chunk.css";
};